import {createFileRoute, Outlet} from "@tanstack/react-router";
import {MainLayout} from "@/layouts/MainLayout";
import {AuthGuard} from "@/guards/AuthGuard";
import {Suspense} from "react";

export const Route = createFileRoute("/_mainLayout")({
  component: () => (
    <AuthGuard to={"/auth"} auth>
      <MainLayout>
        <Suspense>
          <Outlet/>
        </Suspense>
      </MainLayout>
    </AuthGuard>
  ),
});
